import { useEffect } from 'react';
import Slider from 'react-slick';
import styles from './SliderPartners.module.scss';
// import classnames from 'classnames';
import PartnersItemMobile from '../../pages/Partners/PartnersContent/PartnersItemMobile/PartnersItemMobile';
// import { isMobile } from 'react-device-detect';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './defaultStyles.scss';
import Arrow from '../../../images/arrow-blue.svg';

const SliderPartners = ({ array, showNewPartner, activePartner }) => {
  const getCurrent = () => {
    if (array && array.length > 0) {
      const currentSlider = document.querySelector('.parent_slider');
      const currentSlide = currentSlider?.querySelector('.slick-current');
      const currentImageId = currentSlide?.querySelector('img')?.id;
      if (currentImageId) {
        showNewPartner(currentImageId);
      }
    }
  };

  const CustomPrevArrow = (props) => {
    const { style, onClick } = props;
    return (
      <button
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '30px',
          height: '30px',
        }}
        onClick={onClick}>
        <img src={Arrow} alt="Предыдущие новости" width={30} height={30} style={{ display: 'block' }} />
      </button>
    );
  };

  const CustomNextArrow = (props) => {
    const { style, onClick } = props;
    return (
      <button
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '30px',
          height: '30px',
          rotate: '180deg',
        }}
        onClick={onClick}>
        <img src={Arrow} alt="Следующие новости" width={30} height={30} style={{ display: 'block' }} />
      </button>
    );
  };

  useEffect(() => {
    getCurrent();
  }, []);

  const settings = {
    dots: false,
    fade: false,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
  };

  return (
    <div className={styles.slider} id="PartnersSlider" class="parent_slider">
      <Slider
        {...settings}
        slidesToShow={1}
        arrows={true}
        afterChange={() => {
          getCurrent();
        }}
        onInit={() => {
          getCurrent();
        }}
        onReInit={() => {
          getCurrent();
        }}
        className="center"
        centerMode={true}
        centerPadding={0}>
        {array &&
          array.map((item) => <PartnersItemMobile id={item.id} key={item.id} onClick={showNewPartner} item={item} />)}
      </Slider>
    </div>
  );
};

export default SliderPartners;
